import request from '@/utils/request';

// 查询location_area列表
export function listLocationArea(query) {
  return request({
    url: '/ep2/locationArea/list',
    method: 'get',
    params: query,
  });
}

// 查询location_area详细
export function getLocationArea(id) {
  return request({
    url: `/ep2/locationArea/${id}`,
    method: 'get',
  });
}

// 新增location_area
export function addLocationArea(data) {
  return request({
    url: '/ep2/locationArea',
    method: 'post',
    data,
  });
}

// 修改location_area
export function updateLocationArea(data) {
  return request({
    url: '/ep2/locationArea',
    method: 'put',
    data,
  });
}

// 删除location_area
export function delLocationArea(id) {
  return request({
    url: `/ep2/locationArea/${id}`,
    method: 'delete',
  });
}
